// @ts-nocheck
(function () {
  function getRoot() {
    var root =
      window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string'
        ? window.Shopify.routes.root
        : '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function getCartDrawerBody() {
    return document.querySelector('[js-cart-drawer="body"]');
  }

  function getCartDrawerContainer() {
    return document.getElementById('cartDrawer');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    var number = (Number(cents) || 0) / 100;
    var fixed = number.toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? dollars + decimal + parts[1] : dollars;
  }

  function formatMoney(cents, format) {
    var value = Number(cents);
    if (!isFinite(value)) value = 0;
    var moneyFormat =
      typeof format === 'string' && format
        ? format
        : (window.theme && window.theme.moneyFormat) || '{{amount}}';
    var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    var formatted = '';

    switch (placeholder) {
      case 'amount':
        formatted = formatWithDelimiters(value, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        formatted = formatWithDelimiters(value, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        formatted = formatWithDelimiters(value, 0, ' ', '.');
        break;
      default:
        formatted = formatWithDelimiters(value, 2, ',', '.');
        break;
    }

    return moneyFormat.replace(match ? match[0] : '{{amount}}', formatted);
  }

  function getItemTitle(item) {
    return item && (item.product_title || item.title || '');
  }

  function getItemVariantTitle(item) {
    var variant = item && (item.variant_title || '');
    if (!variant || variant === 'Default Title') return '';
    return variant;
  }

  function getItemUrl(item) {
    return (item && item.url) || '';
  }

  function getItemImage(item) {
    return (item && item.image) || (item && item.featured_image && item.featured_image.url) || '';
  }

  function getItemImageAlt(item) {
    return (item && item.featured_image && item.featured_image.alt) || getItemTitle(item);
  }

  function getLinePrice(item) {
    if (!item) return 0;
    if (typeof item.final_line_price === 'number') return item.final_price;
    if (typeof item.line_price === 'number') return item.line_price;
    if (typeof item.final_price === 'number' && typeof item.quantity === 'number')
      return item.final_price;
    if (typeof item.price === 'number' && typeof item.quantity === 'number')
      return item.price;
    return 0;
  }

  function renderLineItem(item) {
    var url = getItemUrl(item);
    var title = getItemTitle(item);
    var variantTitle = getItemVariantTitle(item);
    var img = getItemImage(item);
    var imgAlt = getItemImageAlt(item);
    var qty = item && item.quantity != null ? Number(item.quantity) : 0;
    var key = (item && item.key) || '';
    var linePrice = getLinePrice(item);
    var priceHtml =
      '<span data-price=\"' +
      escapeHtml(linePrice) +
      '\" js-currency=\"price\">' +
      escapeHtml(formatMoney(linePrice)) +
      '</span>';

    var imageHtml = '';
    if (img) {
      imageHtml =
        '<div class=\"ajax-cart__image responsive-image__wrapper\">' +
        '<img alt=\"' +
        escapeHtml(imgAlt) +
        '\" sizes=\"auto\" src=\"' +
        escapeHtml(img) +
        '\">' +
        '</div>';
    }

    var variantHtml = '';
    if (variantTitle) {
      variantHtml =
        '<p class=\"ajax-cart__variant-title caption\">' + escapeHtml(variantTitle) + '</p>';
    }

    return (
      '<div class=\"ajax-cart__line-item\" js-ajax-cart=\"lineItem\">' +
      imageHtml +
      '<div class=\"ajax-cart__description\">' +
      '<div class=\"row no-margin\">' +
      '<div class=\"col xs7 m7\">' +
      '<div class=\"ajax-cart__inner\">' +
      '<a class=\"ajax-cart__title\" href=\"' +
      escapeHtml(url) +
      '\" tabindex=\"0\">' +
      escapeHtml(title) +
      '</a>' +
      variantHtml +
      '<button class=\"ajax-cart__remove\" tabindex=\"0\" data-key=\"' +
      escapeHtml(key) +
      '\" js-ajax-cart=\"remove\">' +
      escapeHtml(
        (window.theme &&
          window.theme.strings &&
          window.theme.strings.cart &&
          window.theme.strings.cart.general &&
          window.theme.strings.cart.general.remove) ||
          'Remove'
      ) +
      '</button>' +
      '</div>' +
      '</div>' +
      '<div class=\"col xs5 m5\">' +
      '<div class=\"ajax-cart__amount\" data-label=\"' +
      escapeHtml(
        (window.theme &&
          window.theme.strings &&
          window.theme.strings.cart &&
          window.theme.strings.cart.label &&
          window.theme.strings.cart.label.price) ||
          'Price'
      ) +
      '\">' +
      '<div class=\"ajax-cart__quantity\">' +
      escapeHtml(qty) +
      ' &times; </div>' +
      '<div class=\"ajax-cart__price\">' +
      priceHtml +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  function setSubtotal(cart) {
    var subtotalEl = document.querySelector('[js-ajax-cart=\"subtotal\"]');
    if (!subtotalEl || !cart) return;
    var total = typeof cart.total_price === 'number' ? cart.total_price : 0;
    subtotalEl.setAttribute('data-price', String(total));
    subtotalEl.textContent = formatMoney(total);
  }

  function applyCartDrawerRenderFix(cart) {
    var drawer = getCartDrawerContainer();
    var body = getCartDrawerBody();
    if (!drawer || !body) return;
    if (!cart || !Array.isArray(cart.items)) return;

    if (cart.item_count <= 0) {
      body.innerHTML =
        '<p>' +
        escapeHtml(
          (window.theme &&
            window.theme.strings &&
            window.theme.strings.cart &&
            window.theme.strings.cart.general &&
            window.theme.strings.cart.general.empty) ||
            'Your cart is empty'
        ) +
        '</p>';
      setSubtotal({ total_price: 0 });
      return;
    }

    var html = '';
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (!item) continue;
      var productType = (item.product_type || '').toLowerCase();
      if (productType === 'add-on') continue;
      html += renderLineItem(item);
    }

    if (html) {
      body.innerHTML = html;
    }

    setSubtotal(cart);
  }

  var pendingCartRequest = null;
  function fetchCart() {
    if (pendingCartRequest) return pendingCartRequest;

    var url = getRoot() + 'cart.js?no-cache=' + Date.now();
    pendingCartRequest = fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(function () {
        return null;
      })
      .then(function (cart) {
        pendingCartRequest = null;
        return cart;
      });

    return pendingCartRequest;
  }

  function init() {
    var bus = window.Frame && window.Frame.EventBus;
    if (!bus || typeof bus.listen !== 'function') return;

    bus.listen('AjaxCart:updated', function (payload) {
      var cart = payload && payload.data ? payload.data : payload;
      applyCartDrawerRenderFix(cart);
    });

    bus.listen('Toggle:cartDrawer:open', function () {
      fetchCart().then(function (cart) {
        if (!cart) return;
        applyCartDrawerRenderFix(cart);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
